module.exports = __webpack_public_path__ + "img/icon-cencosud.14f9105f.png";